module.exports = __webpack_public_path__ + "static/img/dnzlzz_1.5c32f684.png";